var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-for-future-days"},[_c('SetForFutureDays',{attrs:{"references":_vm.inventoryGroups,"inventory-fields":['shared_inventory_limit', 'sale_stop']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }